import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer, Legend, Tooltip } from "recharts";

const PALETTE = ["#10b981", "#8b5cf6", "#f59e0b", "#0ea5e9", "#ef4444"];

/**
 * NovaCriteriaRadarCompare — superpone 2-3 (hasta 5) retos en un mismo radar.
 * Props:
 *   items: [{ label, score:{per_criterion:{key:{avg}}}, color? }]
 *   criteria: [{key,label,weight}]
 *   height: default 340
 */
export default function NovaCriteriaRadarCompare({ items, criteria, height = 340 }) {
  if (!items?.length || !criteria?.length) return null;

  const data = criteria.map((c) => {
    const row = { subject: c.label, fullMark: 5 };
    items.forEach((it, i) => {
      row[`s${i}`] = Number(it.score?.per_criterion?.[c.key]?.avg || 0);
    });
    return row;
  });

  return (
    <div className="w-full" data-testid="criteria-radar-compare">
      <ResponsiveContainer width="100%" height={height}>
        <RadarChart data={data} outerRadius="65%">
          <PolarGrid stroke="#cbd5e1" />
          <PolarAngleAxis dataKey="subject" tick={{ fontSize: 11, fill: "#475569" }} />
          <PolarRadiusAxis angle={90} domain={[0, 5]} tick={{ fontSize: 9, fill: "#94a3b8" }} tickCount={6} />
          <Tooltip />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          {items.map((it, i) => {
            const color = it.color || PALETTE[i % PALETTE.length];
            return (
              <Radar key={i} name={it.label} dataKey={`s${i}`} stroke={color} fill={color} fillOpacity={0.25} />
            );
          })}
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
